import HybrisCartAPI from './HybrisCartAPI';
// import SwaCartAPI from './SwaCartAPI';
// import * as featureFlags from '../utilities/featureFlags';
let cartApi;

// As suggested by Suri, we are removing HyBrisIntegrationCode, so for now commenting it
// if (featureFlags.EnableHybrisIntegration.isEnabled()) {
cartApi = new HybrisCartAPI();
// } else {
//   cartApi = new SwaCartAPI();
// }
export default cartApi;



// WEBPACK FOOTER //
// ./assets/services/CartAPI.js